const styles = (theme) => ({
  boxList: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
});

export default styles;
